import { render } from "./total-table.vue?vue&type=template&id=fa7ca788&scoped=true"
import script from "./total-table.vue?vue&type=script&lang=js"
export * from "./total-table.vue?vue&type=script&lang=js"

import "./total-table.vue?vue&type=style&index=0&id=fa7ca788&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa7ca788"]])

export default __exports__